import { useMutation } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import Api from '@/services/api';
import { BaseContext } from '@/types';

export type DownloadPDF = BaseContext & {
	id?: string;
	locale: string;
	selected_pdf_sections?: string[];
};

async function downloadPDF(payload: DownloadPDF) {
	const url = 'ergonomic-tool/rosa/document/pdf';
	const { data } = await Api.post<any>(url, payload);
	return data;
}

export const useDownloadPDF = () => {
	return useMutation((body: DownloadPDF) => downloadPDF(body), {
		onError: () => {
			message.error(I18n.get('Failed to generate PDF'));
		}
	});
};
